import React from 'react';
import { useTranslation } from 'react-i18next';
import RenderIrrigationRanch from './RenderIrrigationRanch';

interface Ranch {
  id: string | number;
  name: string;
}

interface SweetPotatoReplicationControlProps {
  ranches: Ranch[];
}

const SweetPotatoReplicationControlSection: React.FC<SweetPotatoReplicationControlProps> = (
  props: any
) => {
  const { ranches } = props;
  const { t } = useTranslation();

  return (
    <section>
      <div className="auto-schedule-buttons-wrapper padding-10" />
      {ranches.map((ranch: any) => (
        <RenderIrrigationRanch
          key={ranch.id}
          ranch={ranch}
          isSweetPotatoReplication
        />
      ))}
    </section>
  );
};

export default SweetPotatoReplicationControlSection;
